import * as React from "react";

const Hamburger: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M4 5H20V7H4V5ZM4 11H20V13H4V11ZM20 17H4V19H20V17Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(Hamburger);
